import { X } from 'lucide-react'
import { PropsWithChildren, useState } from 'react'
import Card from './Card'
import LinkButton from '@/components/ui/link-button'

type Props = PropsWithChildren<{
  title: string
  uid: string
  actions: {
    label: string
    href: string
  }[]
  dismissible?: boolean
}>

const CallToAction = ({ dismissible = true, ...props }: Props) => {
  const [closed, setClosed] = useState(
    dismissible && localStorage.getItem(`cta-${props.uid}`) === 'closed',
  )

  if (closed) {
    return null
  }

  return (
    <Card className='border-primary my-4'>
      <h4 className='flex items-center justify-between'>
        {props.title}
        {dismissible ? (
          <X
            size={16}
            className='cursor-pointer mr-2'
            onClick={() => {
              setClosed(true)
              localStorage.setItem(`cta-${props.uid}`, 'closed')
            }}
          />
        ) : null}
      </h4>
      <div>{props.children}</div>
      <div className='mt-4 flex gap-2'>
        {props.actions.map((action, i) => (
          <LinkButton key={i} to={action.href} target='_blank' rel='noreferrer'>
            {action.label}
          </LinkButton>
        ))}
      </div>
    </Card>
  )
}

export default CallToAction
